import { render, staticRenderFns } from "./ConfigVoip.vue?vue&type=template&id=e44e543c&"
import script from "./ConfigVoip.vue?vue&type=script&lang=js&"
export * from "./ConfigVoip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports